var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPolitica(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#020C41;stroke-width:1.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "30.1,5.3 30.1,12 36.8,12  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.8,38.1c0,0.7-0.5,1.2-1.2,1.2H12.1c-0.7,0-1.2-0.5-1.2-1.2V6.5c0-0.7,0.5-1.2,1.2-1.2h18.7 c0.3,0,0.5,0.1,0.7,0.4l5,4.9c0.2,0.2,0.4,0.5,0.4,0.8v26.7H36.8z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 30.9,
    y1: 21.6,
    x2: 17.4,
    y2: 21.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 30.9,
    y1: 27.1,
    x2: 17.4,
    y2: 27.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 30.9,
    y1: 32.5,
    x2: 17.4,
    y2: 32.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 25.8,
    y1: 16.1,
    x2: 17.1,
    y2: 16.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.6,10.4c-0.7,0-1.2,0.6-1.2,1.2v31.7c0,0.7,0.6,1.2,1.2,1.2h25.7c0.7,0,1.2-0.6,1.2-1.2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolitica);
export default __webpack_public_path__ + "static/media/politica.eec8f87442ade89cebe0c9f3a0cff918.svg";
export { ForwardRef as ReactComponent };